import React from 'react'
import { Link } from 'react-router-dom'
import ls from 'local-storage'
import { connect } from 'react-redux';
// import JSEncrypt from 'jsencrypt'


import Header from '../components/header'
import Footer from '../components/footer'
import LoginModal from '../components/loginModal'
import SignupModal from '../components/signupModal'

import * as PrimaryServices from '../services/service'
import * as GlobalActions from '../store/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import * as SetWidget from '../operationalHelper/populateWidget'
import * as Const from '../constants/constants'


class EOL extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        document.title = "EOL, EOS Policy - Aviatrix"
        SetWidget.populateWidget()
    }



  render() {
    const fontStyle = {
        fontFamily: '"Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        fontWeight: 400,
        fontSize: '1em',
        lineHeight: '1.714',
    };

    return (
        <React.Fragment>
            <div className="min-height-full">
                {/* ==== Header for Page ==== */}
                <Header parent="SLA"></Header>
                 <br />
                    <br />
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/> 
                <div className="container width-wrapper pt-5 p-md-b-5" style={fontStyle}>
                    <div className="mb-5">
                        <h1 style={{ fontSize: '28px', fontWeight: 1000, marginBottom: '4px' }}>
                            Aviatrix Support: End-of-Life and End-of-Support Policy
                        </h1>
                        <p style={{ fontSize: '14px', color: '#666' }}>Updated: May 19 2025</p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>1. Introduction</h2>
                        <p>
                            This document outlines the official End-of-Life (EoL) and End-of-Support (EoS) policies for Aviatrix
                            Controller and Gateway software ("Aviatrix Software"). These policies provide predictable guidelines
                            for lifecycle management, enabling customers to plan their upgrade cycles effectively. Aviatrix targets
                            three (3) Major.Minor (major.minor) software releases per year, although actual release dates may vary
                            based on product development and market requirements. Patch releases (.patch) inherit the EoL/EoS
                            timeline of their parent Major.Minor release.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 1000, marginBottom: '8px' }}>2. Policy Goals & Support Scope</h2>
                        <p>
                            <strong>Active Patching:</strong> Aviatrix actively develops patches (bug fixes, maintenance updates, security fixes)
                            for the two (2) most recent Generally Available (GA) Major.Minor releases.
                        </p>
                        <p>
                            <strong>Technical Support:</strong> Technical support is provided for releases that have not reached their
                            End-of-Support date. This policy provides a defined period of technical support after routine patching ends.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>3. Definitions</h2>
                        <p>
                            <strong>General Availability (GA) Date:</strong> The date a specific Major.Minor software release is officially
                            published and made available to customers.
                        </p>
                        <p>
                            <strong>End-of-Life (EoL):</strong> The milestone after which Aviatrix Engineering ceases providing routine
                            patches (bug fixes, maintenance updates) for a specific Major.Minor release (N).
                        </p>
                        <p>
                            <strong>End-of-Support (EoS):</strong> The final date Aviatrix Technical Support provides technical assistance or
                            accepts support requests for a specific Major.Minor release (N).
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>4. Lifecycle Milestones & Timelines</h2>
                        <p>
                            <strong>End-of-Life (EoL) Date:</strong> The EoL date for release (N) is generally expected to be after at least one patch is available for N+1, and before the General Availability (GA) Date of the second subsequent Major.Minor release (N+2).
                        </p>
                        <p>
                            <em>Example: EoL date for 8.0 is on or after the availability of 8.1.10, but before the GA Date of 8.2.</em>
                        </p>
                        <p>
                            <strong>Impact:</strong> After a release reaches EoL, routine patching ceases and the release enters the support-only phase.
                        </p>
                        <p>
                            <strong>End-of-Support (EoS) Date:</strong> The EoS date for release (N) is six (6) months after its End-of-Life (EoL) Date.
                        </p>
                        <p>
                            <strong>Minimum Commitment:</strong> Regardless of release timelines, Aviatrix guarantees that each Major.Minor release will be supported for at least 12 months from its GA date.
                        </p>
                        <p>
                               <em>Example: EoS date for 8.0 would be 6 months after its EoL date, but no earlier than 12 months after the GA date of 8.0.</em>

                        </p>
                        <p>
                            <strong>Impact:</strong> Provides customers with a guaranteed minimum support lifecycle, regardless of release cadence changes.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>5. Supported & Patched Releases</h2>
                        <p>
                            <strong>Active Patching Scope:</strong> Aviatrix actively patches the two most recent GA Major.Minor releases. Routine patching for release N will cease after at least one patch is available for N+1, but before N+2 becoming GA.
                        </p>
                        <p>
                            <strong>Security Vulnerability Exception:</strong> Aviatrix may, at its sole discretion, provide patches for critical security vulnerabilities for releases that have reached End-of-Life but have not yet reached End-of-Support.
                        </p>
                        <p>
                            <strong>Technical Support Scope:</strong> Aviatrix provides technical support for all Major.Minor releases that have not reached their End-of-Support date.
                        </p>
                        <p>
                            <strong>Fix Forward Approach:</strong> Aviatrix follows a "fix forward" methodology. This means that while resolution often requires upgrading to one of the actively patched releases, Aviatrix support will assist in identifying potential workarounds for supported versions where feasible.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>6. Planning for Success</h2>
                        <p>
                            Customers are responsible for managing their software lifecycle and planning upgrades before a release reaches its EoS date. Staying current ensures access to patches, features, and support. We recommend that customers consider both EoL (end of patching) and EoS (end of support) dates in their planning cycles to ensure continuous support coverage.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>7. Aviatrix CoPilot</h2>
                        <p>
                            Aviatrix CoPilot follows a continuous delivery model with automatic updates. Only the latest release of CoPilot is supported, and CoPilot may only work fully with actively supported Controller releases. For optimal performance and functionality, we recommend using CoPilot with the most current Controller version. Please refer to CoPilot release notes for specific compatibility requirements.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>8. EoL & EoS Schedule Publication</h2>
                        <p>
                            Note that EoS/EoL dates will not be announced when a release is published as they are relative to subsequent releases and release timing. These dates will be confirmed and published as future releases become available.
                        </p>
                    </div>

                    <div className="mb-5">
                        <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>9. Policy Changes</h2>
                        <p>
                            Aviatrix reserves the right to update this End-of-Life Policy. Any changes to this policy will not shorten the support period for releases that have already been made Generally Available.
                        </p>
                    </div>
                    <div className="mb-5">
                    <h2 style={{ fontSize: '24px', fontWeight: 900, marginBottom: '8px' }}>Aviatrix EoL/EoS Schedule & Support Duration</h2>
                   <div className="overflow-x-auto row">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr style={{ backgroundColor: '#f97316', color: 'white' }}>
                                <th style={{ padding: '8px 16px', border: '1px solid white', width:'10%'  }}>Release (N)</th>
                                <th style={{ padding: '8px 16px', border: '1px solid white', width:'20%'  }}>GA Date (N)</th>
                                <th style={{ padding: '8px 16px', border: '1px solid white', width:'25%'  }}>EoL Date</th>
                                <th style={{ padding: '8px 16px', border: '1px solid white', width:'25%'   }}>EoS Date</th>
                                <th style={{ padding: '8px 16px', border: '1px solid white', width:'20%'   }}>Status (as of 12 May 2026)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>6.8</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Aug 09 2022</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Aug 09 2023</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Nov 09 2023</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>EoS</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>6.9</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Sep 09 2022</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Jan 09 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Apr 09 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>EoS</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>7.0</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Dec 08 2022</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Apr 08 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Jul 08 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>EoS</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>7.1</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>May 11 2023</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Oct 31 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Jul 31 2025</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>EoS</td>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>7.2</th>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Oct 15 2024</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Oct 15 2025</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Apr 15 2026</td>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>EoS</td>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>8.0</th>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>May 19 2025</td>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Dec 22 2025</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Dec 22 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>8.1</th>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Aug 11 2025</td>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Jun 30, 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Apr 15 2027</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>8.2</th>
                                <td style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Dec 22 2025</td>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Oct 31, 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Jun 30, 2027</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>9.0</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>May 13, 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Q1 2027</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Dec 31, 2027</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>10.0</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Aug 13, 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Not Announced</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Not Announced</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                            <tr>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f97316', color: 'white',  }}>10.1</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Sep 17, 2026</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Not Announced</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Not Announced</th>
                                <th style={{ padding: '8px 16px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',  }}>Supported</th>
                            </tr>
                        </tbody>
                    </table>
</div>
                    </div>
                </div>
                 <br />
                    <br />
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/> 
                {/* ==== Footer Component ==== */}
                <Footer></Footer>
            </div>
        </React.Fragment>
    );
}
}

export default EOL


// export default Home;